import { render } from "./SimuladorAhorro.vue?vue&type=template&id=45b40cef&scoped=true"
import script from "./SimuladorAhorro.vue?vue&type=script&lang=js"
export * from "./SimuladorAhorro.vue?vue&type=script&lang=js"

import "./SimuladorAhorro.vue?vue&type=style&index=0&id=45b40cef&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b40cef"]])

export default __exports__